module.exports = __webpack_public_path__ + "img/liechtenstein.4277b57.webp";